<template>
	<div>
		<div class="icons-main-container">
			<div v-if="showInput">
				<h2 class="label-icon"
					:style="`color:${$appColors.info}`"
				>Ícono</h2>
				<load-input
					:allowed-file-extensions="allowedFileExt"
					:value="urlImage"
					@input="getUrlImage"
				/>
				<div v-if="urlImage" class="icon-name-container">
					<label :style="`color:${$appColors.info}`" class="icon-name">
						Nombre
						<input
							class="new-survey-input" 
							placeholder="Nombre"
							v-model="name"
							@keyup.enter="createIcon"
						/>
					</label>
					<app-button
						:disabled="!name"
						class="add-icon"
						icon="add"
						@click="createIcon"
					/>
				</div>
			</div>
			<div class="icon-grid-main-container"
				:style="`border:1px solid ${$appColors.gray};color:${$appColors.info}`"
			>
				<div class="searcher"
					:style="`border:1px solid ${$appColors.gray}`"
				>
					<input class="icons-searcher" v-model="search"/>
					<v-icon>search</v-icon>
				</div>
				<div class="icons-grid-container">
					<div
						v-for="(icon, indexIcon) in computedIcons"
						:key="indexIcon"
						:class="[
							'icon-card',
							{ 'icon-card-selected': icon.id === iconSelectedId },
						]"
						:style="iconCardStyle"
						@click="selectingIcon(icon)"
					>
						<img :src="icon.urlImage" alt="ícono" class="icon-award">
						<span
							class="icon-name"
							:style="`color:${$appColors.primary}`"
						>{{icon.name}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import loadInput from '@/components/shared/load-file-input';
import appButton from '@/components/shared/app-button';
import { mapGetters } from 'vuex';

function computedIcons() {
	if (this.search) {
		const regex = new RegExp(this.search, 'i');
		return this.icons.filter(i => regex.test(i.name));
	}
	return this.icons;
}

function selectingIcon(icon) {
	this.$store.dispatch('icon/selectIconAction', icon);
}

function iconCardStyle() {
	const border = `border:1px solid ${this.$appColors.gray};`;
	const selected = `border:1px solid ${this.$appColors.primary};`;
	return selected ? `${border};${selected}` : `${border}`;
}

function getUrlImage(urlImage) {
	this.urlImage = urlImage;
	this.$emit('input', urlImage);
}

async function createIcon() {
	const body = {
		name: this.name,
		type: [this.$route.params.type],
		urlImage: this.urlImage,
	};
	await this.$store.dispatch('icon/create', body);
	this.showNotification(
		`Ícono: ${this.name} agregado con éxito`,
		'success',
	);
	this.name = '';
	this.urlImage = '';
}

function data() {
	return {
		name: '',
		search: '',
		urlImage: '',
	};
}

export default {
	name: 'icons-grid-component',
	components: {
		appButton,
		loadInput,
	},
	computed: {
		...mapGetters('icon', [
			'iconSelectedId',
		]),
		computedIcons,
		iconCardStyle,
	},
	data,
	methods: {
		createIcon,
		getUrlImage,
		selectingIcon,
	},
	props: {
		allowedFileExt: {
			type: String,
			default: '',
		},
		icons: {
			required: true,
			type: Array,
		},
		showInput: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.icons-main-container {
	background-color: color(gray-light);
	height: calc(100vh - 200px);
	padding: 14px 20px;

	.label-icon {
		font-size: size(medium);
	}

	.icon-grid-main-container {
		background-color: white;
		border-radius: 4px;
		margin-top: 26px;
		padding: 14px 10px;

		.searcher {
			align-items: center;
			background-color: white;
			border-radius: 4px;
			display: flex;
			height: 33px;
			justify-content: flex-start;
			margin-bottom: 16px;
			padding: 3px;

			.icons-searcher {
				flex-basis: 93%;

				&:focus {
					outline: none;
				}
			}
		}

		.icons-grid-container {
			align-items: center;
			display: grid;
			grid-gap: 10px;
			grid-template-columns: repeat(auto-fit, minmax(75px, 77px));

			.icon-card {
				align-items: center;
				border-radius: 4px;
				cursor: pointer;
				display: flex;
				flex-direction: column;
				padding: 23px;

				&:hover {
					border: 1px solid color(primary);
				}

				.icon-award {
					height: 30px;
					margin-bottom: 15px;
				}
			}

			.icon-card-selected {
				box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
					0 6.7px 5.3px rgba(0, 0, 0, 0.048),
					0 12.5px 10px rgba(0, 0, 0, 0.06),
					0 22.3px 17.9px rgba(0, 0, 0, 0.072),
					0 41.8px 33.4px rgba(0, 0, 0, 0.086),
					0 100px 80px rgba(0, 0, 0, 0.12);
				transition: box-shadow 180ms ease-in-out;
			}
		}
	}

}

.icon-name-container {
	align-items: flex-end;
	display: flex;
	margin-top: 15px;

	.icon-name {
		flex-basis: 90%;
	}

	.add-icon {
		flex-basis: 10%;
		height: 35px;
		margin-left: 5px;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/shared/icons/icons-grid-components.vue